
export default {
    // @BusinessContract
    setNewCreatedBusinessContract(state, value){
        state.newCreatedBusinessContract = value
    },
    setNewCreatedDriverContract(state, value){
        state.newCreatedDriverContract = value
    },
}